var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"perfect_container"}},[_c('div',{staticClass:"perfect_header"},[_c('p',[_vm._v("打造完整线上数据")])]),_c('div',{staticClass:"perfect_img"},[_c('img',{attrs:{"src":require("../assets/images/数据图形-pc.png"),"alt":""}})])])
}]

export { render, staticRenderFns }